/**
 * Parses a string as an integer and checks whether that integer is safe,
 * that is, if it is represented exactly (no round off error, which is
 * possible for the native JS 'number' type that is within the range [-(2**53 - 1), 2**53 - 1])
 *
 * "A safe integer is an integer that:
 *  can be exactly represented as an IEEE-754 double precision number, and
 *  whose IEEE-754 representation cannot be the result of rounding any other integer to fit the IEEE-754 representation"
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isSafeInteger
 *
 * @param value - The value of the column that is of Postgres BIGINT type
 * @returns - The parsed JS number
 */
export function parseStringAsSafeInt(value: string): number {
    const valueAsInt = Number.parseInt(value, 10);
    if (Number.isSafeInteger(valueAsInt)) {
        return valueAsInt;
    } else {
        throw new Error(`${valueAsInt} cannot be safely represented as an integer using the native JS number type`);
    }
}
